import { bindable } from 'aurelia';


export class OfferModal {
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    offerModalContainer;

    @bindable openedHotel;
    @bindable packageGroup;

    offerFormChildAges = [];
    offerFormAdultCount = 1;
    ages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    formSubmittionProgress = "not submitted";
    aurelia_options = window.aurelia_options;

    // Component does not reset state on unmount
    bind() {
        this.formSubmittionProgress = "not submitted";
        this.offerFormChildAges = [];
        this.offerFormAdultCount = 1;
    }

    attached() {
        if (this.packageGroup !== null && this.openedHotel !== null) {
            this.showInquiryForm();
        }
    }

    closeDropdown(e) {
        if (e !== undefined) {
            let clickOnScroll = e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight;
            if (clickOnScroll) {
                return;
            }
        }
        this.offerModalContainer.close();
        this.openedHotel = null;
        this.offerModalContainer.dispatchEvent(new CustomEvent(`e-close-modal`, {
            bubbles: true,
        }));
    }

    async showInquiryForm() {
        let apiURL = this.aurelia_options.last_minute_trips_api_location + `gravity_form?lang=${this.aurelia_options.language}`;
        let response = await fetch(apiURL);
        let result = await response.json();

        let gf_id = `gravity-form-container-${this.packageGroup.packagegroup_id}`;
        let formContainer = document.querySelector('#' + gf_id);
        
        formContainer.innerHTML = result.html;
        
        if (sessionStorage.logged_in_user !== undefined) {
            try {
                let loggedInUser = JSON.parse(sessionStorage.logged_in_user);
                
                document.querySelector(`#${gf_id} input[autocomplete=name]`).value = loggedInUser.firstname + " " + loggedInUser.lastname;
                document.querySelector(`#${gf_id} input[autocomplete=email]`).value = loggedInUser.email;
                document.querySelector(`#${gf_id} input[autocomplete=tel]`).value = loggedInUser.phone;
            } catch (e) {

            }
        }
        
        let form = this.offerModalContainer.querySelector(`form[id^="gform_"]`);
        // span is needed to get right arrow from site styles
        form.querySelector(`button[type=submit]`).outerHTML = `<button type="submit" class="e5-btn e5-btn-highlight w-full">
            <span>${form.querySelector(`button[type=submit]`).innerText}</span>
        </button>`;
        let formSubmittedFromPageInput = Array.from(this.offerModalContainer.querySelectorAll('input.gform_hidden')).find(input => input.value.trim() === apiURL);
        if (formSubmittedFromPageInput !== undefined) {
            formSubmittedFromPageInput.value = window.location.href;
        }
        form.action = this.aurelia_options.rootUrl;
        this.offerModalContainer.showModal();
    }

    async handleSubmit(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.formSubmittionProgress !== "not submitted") {
            return;
        }
        let formContainer = document.querySelector(`#gravity-form-container-${this.packageGroup.packagegroup_id}`);
        
        this.formSubmittionProgress = "bending";
        
        let form = this.offerModalContainer.querySelector(`form[id^="gform_"]`);
        let isValid = true;
        this.offerModalContainer.querySelectorAll('.js-check-age-validity').forEach(x => {
            let isSelectInvalid = parseInt(x.value) === NaN || !this.ages.includes(parseInt(x.value));
            x.classList.toggle('e5-error', isSelectInvalid);
            if (isSelectInvalid) {
                isValid = false;
            }
        })

        // Form might still be invalid as Gravity Form fields can only be validated server side
        if (!isValid) {
            this.offerModalContainer.querySelector('.js-offer-form-traveler-subform').scrollIntoView({ behavior: "smooth" });
            return;
        }

        let dynamicData = ""
        + `${this.aurelia_options.translations.lmt_triplist_header_destination}: ${this.getDestination(this.packageGroup)}\n`
        + `${this.aurelia_options.translations.lmt_destination_body_hotel}: ${this.openedHotel.hotel}${this.openedHotel.category != 0 ? (' ' + this.openedHotel.category + '*') : ''}\n`
        + `${this.aurelia_options.translations.lmt_hotel_readmoreinfo}: ${this.openedHotel.info[this.aurelia_options.language] !== undefined ? (this.aurelia_options.estravel_hotelinfo_weburl[this.aurelia_options.language] + this.openedHotel.info[this.aurelia_options.language]) : '-'}\n`
        + `${this.aurelia_options.translations.lmt_destination_body_roomtype}: ${this.getSelectedRoomTypeName(this.openedHotel.rooms, this.openedHotel.selected_room_id)}\n`
        + `${this.aurelia_options.translations.lmt_destination_body_mealplan}: ${this.getSelectedMealplanName(this.openedHotel.rooms, this.openedHotel.selected_mealplan_id)}\n`
        + `${this.aurelia_options.translations.lmt_destination_header_departure}: ${this.getDepartureDateText(this.openedHotel)}\n`
        + `${this.aurelia_options.translations.offer_form_duration}: ${this.packageGroup.total_nights} ${this.aurelia_options.translations.lmt_destination_body_durationnights}\n`
        + `${this.aurelia_options.translations.lmt_destination_header_departurefrom}: ${this.getDepartureCityText(this.packageGroup)}\n`
        + `${this.aurelia_options.translations.offer_form_tour_operator}: ${this.openedHotel.service}\n`
        + `${this.aurelia_options.translations.lmt_destination_body_price}: ${this.getSelectedHotelPrice(this.openedHotel)}€\n`
        + `\n`
        + `${this.aurelia_options.translations.offer_form_adults}: ${this.offerFormAdultCount}\n`
        + (this.offerFormChildAges.length > 0 ? `${this.aurelia_options.translations.offer_form_children}: ${this.offerFormChildAges.length} (${this.offerFormChildAges.join(', ')})\n` : '');

        form.querySelector(`.dynamic-offer-info`).querySelector('textarea').innerHTML = dynamicData;
        form.querySelector(`.js-offer-info-country`).querySelector('input').value = this.packageGroup.country_info[this.aurelia_options.language] ?? this.packageGroup.country;
        form.querySelector(`.js-offer-info-resort`).querySelector('input').value = this.packageGroup.resort_info[this.aurelia_options.language] ?? this.packageGroup.resort;
        form.querySelector(`.js-offer-info-other-info`).querySelector('textarea').innerHTML = ``
        + `Package Group ID: ${this.openedHotel.packagegroup_id}\n`
        + `Package ID: ${this.openedHotel.selected_mealplan_id}\n`;
        
        try {
            let response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form)
            });
            let result = await response.text();
            let resultBody = new DOMParser().parseFromString(result, 'text/html').body;
            let success = resultBody.querySelector('button[type=submit]') === null;
            if (success) {
                window.dataLayer.push({ event: 'gform_submit_lmo' })
                this.formSubmittionProgress = "submitted";
                formContainer.innerHTML = resultBody.innerHTML;
                formContainer.innerHTML = `<div class="mb-8">${resultBody.innerHTML}</div>`;
            } else {
                this.formSubmittionProgress = "not submitted";
                formContainer.innerHTML = resultBody.innerHTML;
                this.offerModalContainer.querySelector(".js-offer-form-gravity-subform").scrollIntoView({ behavior: "smooth" });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            formContainer.innerHTML = `<div class="rounded-md p-8 border border-error-text text-error-text bg-error-surface mb-8">${this.aurelia_options.translations.offer_form_submit_error}</div>`;
            this.formSubmittionProgress = "not submitted";
        }
    }

    getSelectedRoomTypeName(rooms, selected_room_id) {
        let selectedRoom = rooms.find(x => x.id === selected_room_id);
        return selectedRoom.name;
    }

    getSelectedMealplanName(rooms, selected_mealplan_id) {
        let selectedMealplan = rooms.flatMap(x => x.mealplans).find(x => x.id === selected_mealplan_id);
        return this.aurelia_options.translations.lmt_mealplans[selectedMealplan.sort];
    }

    getDepartureDateText(hotel) {
        return hotel.departure_date.substring(8, 10) + "." + hotel.departure_date.substring(5, 7) + "." + hotel.departure_date.substring(0, 4);
    }

    getSelectedHotelPrice(hotel) {
        let selectedMealplan = hotel.rooms.flatMap(x => x.mealplans).find(x => x.id === hotel.selected_mealplan_id);
        return Math.round(selectedMealplan.price / 100);
    }

    getDepartureCityText(packageGroup) {
        if (packageGroup.departure_from_city_info[this.aurelia_options.language] != undefined) {
            return packageGroup.departure_from_city_info[this.aurelia_options.language];
        } else {
            return packageGroup.departure_from_city;
        }
    }

    
    getDestination(packageGroup) {
        let destination = "";

        if (packageGroup.country_info[this.aurelia_options.language] !== undefined) {
            destination = packageGroup.country_info[this.aurelia_options.language];
        } else {
            destination = packageGroup.country;
        }

        if (packageGroup.resort_info[this.aurelia_options.language] != undefined) {
            destination = destination + ', ' + packageGroup.resort_info[this.aurelia_options.language];
        } else {
            destination = destination + ', ' + packageGroup.resort;
        }

        return destination;
    }

    offerAdultCountChange(change) {
        this.offerFormAdultCount += change;
    }

    offerChildCountChange(change) {
        if (change < 0) {
            if (this.offerFormChildAges.length === 0) return;
            this.offerFormChildAges.pop();
        } else {
            this.offerFormChildAges.push(null);
        }
    }

    offerChildAgeChange(e, childNo) {
        const target = e.target;
        let childAge = target.value === "-1" ? null : Number(target.value);
        this.offerFormChildAges.splice(childNo, 1, childAge);
    }

    stopPropagation(e) {
        e.stopPropagation();
        return true;
    }

    showLivechat() {
        this.closeDropdown();
        window.LiveChatWidget.call('maximize');
    }
}